import { client, getToken, logout, saveTokens, type Tokens } from "./api-client";
import { type CashDrawer, type CashDrawerApi, cashDrawerFromJson } from "./cash-drawer-client";

export const enum PERMISSIONS {
  EXCHANGE = "EXCHANGE",
  BACK_OFFICE = "BACK_OFFICE",
  ADMIN_SHOP = "ADMIN_SHOP",
  REFUND = "REFUND",
}

export type POS = {
  id: "BACKOFFICE" | number;
  name: string;
  noServiceCharge: boolean;
  address?: { city: string; country: string; street: string; streetNumber: string };
  cashDrawers: CashDrawer[];
};

export type User = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  permissions: PERMISSIONS[];
  pos: POS[];
};

function isLoggedIn() {
  return Boolean(getToken());
}

type UserApi = Omit<User, "pos"> & {
  pos: Array<Omit<User["pos"][number], "cashDrawers"> & { cashDrawers: CashDrawerApi[] }>;
};

async function getUser(): Promise<User | null> {
  if (!isLoggedIn()) return null;

  return await client<UserApi>("api/pos/me")
    .then((user) => ({
      ...user,
      pos: user.pos.map((pos) => ({
        ...pos,
        cashDrawers: pos.cashDrawers.map(cashDrawerFromJson),
      })),
    }))
    .catch(logout);
}

export type LoginData = { email: string; password: string };

async function login(url: string, data: LoginData) {
  await client<Tokens>(`api/pos/${url}/login`, {
    data: { ...data, deviceId: "webpos" },
    handle401: false,
  }).then(saveTokens);

  return await getUser();
}

export { getUser, login, logout };
